import { useState, useEffect } from "react";

export default function PWAInstallPrompt() {
  const [prompt, setPrompt] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setPrompt(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstall = async () => {
    if (!prompt) return;
    prompt.prompt();
    const result = await prompt.userChoice;
    if (result.outcome === "accepted") setShow(false);
  };

  if (!show) return null;

  return (
    <div style={s.wrapper}>
      <div style={s.row1}>
        <div style={s.left}>
          <span style={s.icon}>📦</span>
          <div>
            <p style={s.title}>Install MartSense</p>
            <p style={s.sub}>Add to home screen for quick access</p>
          </div>
        </div>
        <button onClick={() => setShow(false)} style={s.closeBtn}>✕</button>
      </div>
      <div style={s.row2}>
        <button onClick={() => setShow(false)} style={s.dismissBtn}>Not now</button>
        <button onClick={handleInstall} style={s.installBtn}>Install App</button>
      </div>
    </div>
  );
}

const s = {
  wrapper: {
    position: "fixed",
    bottom: "0",
    left: "0",
    right: "0",
    zIndex: 9999,
    background: "#0f1a1a",
    borderTop: "2px solid #2ec4b6",
    padding: "16px 16px 24px 16px",
    boxShadow: "0 -8px 32px rgba(0,0,0,0.5)",
  },
  row1: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "16px",
    width: "100%",
  },
  left: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flex: 1,
    minWidth: 0,
  },
  icon: { fontSize: "28px", flexShrink: 0 },
  title: {
    fontSize: "15px", fontWeight: "700",
    color: "#e8f5f5", marginBottom: "2px",
  },
  sub: { fontSize: "12px", color: "#5a8a8a" },
  closeBtn: {
    background: "none", border: "none",
    color: "#5a8a8a", fontSize: "20px",
    cursor: "pointer", padding: "4px 8px",
    flexShrink: 0,
  },
  row2: {
    display: "flex",
    gap: "12px",
    width: "100%",
  },
  dismissBtn: {
    flex: 1,
    background: "none",
    border: "1px solid #1e3333",
    borderRadius: "10px",
    padding: "14px",
    color: "#5a8a8a",
    fontSize: "15px",
    cursor: "pointer",
    fontFamily: "inherit",
  },
  installBtn: {
    flex: 1,
    background: "linear-gradient(135deg, #2ec4b6, #1a9e92)",
    border: "none",
    borderRadius: "10px",
    padding: "14px",
    color: "#0a0f0f",
    fontSize: "15px",
    fontWeight: "700",
    cursor: "pointer",
    fontFamily: "inherit",
  },
};